// extracted by mini-css-extract-plugin
module.exports = {"dice":"Dice_dice__2Q0ZA"};